import React from 'react';
import {scoreColor, scoreColorForeground} from 'helpers/scoreColors';

interface ScoreRankLabelProps {
  scoreRank: string | null | undefined;
  className?: string;
}

const ScoreRankLabel: React.FC<ScoreRankLabelProps> = ({
  scoreRank,
  className = '',
}) => {
  if (!scoreRank) return null;

  const bgColor = scoreColor(scoreRank);
  const fgColor = scoreColorForeground(scoreRank);

  return (
    <span
      className={`flex items-center justify-center w-6 h-6 rounded border font-bold ${className}`}
      style={{
        backgroundColor: bgColor,
        color: fgColor,
        borderColor: fgColor,
      }}
    >
      {scoreRank}
    </span>
  );
};

export default ScoreRankLabel;
